'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _regeneratorRuntime = require('regenerator-runtime');

var _regeneratorRuntime2 = _interopRequireDefault(_regeneratorRuntime);

var _SimplePrompt = require('./SimplePrompt');

var _SimplePrompt2 = _interopRequireDefault(_SimplePrompt);

var _FuzzyAutocomplete = require('./FuzzyAutocomplete');

var _FuzzyAutocomplete2 = _interopRequireDefault(_FuzzyAutocomplete);

var _StyledDiv = require('./StyledDiv');

var _StyledDiv2 = _interopRequireDefault(_StyledDiv);

var _Buildup = require('./Buildup');

var _Buildup2 = _interopRequireDefault(_Buildup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// 🔮 might not want to rely on a modal


var Commander = function (_Component) {
  _inherits(Commander, _Component);

  function Commander(props) {
    _classCallCheck(this, Commander);

    var _this = _possibleConstructorReturn(this, (Commander.__proto__ || Object.getPrototypeOf(Commander)).call(this, props));

    _this.state = {
      phase: 'command',
      parameter: {},
      parameterItems: {},
      enteredCommands: []
    };

    _this.selectParameterItem = function (item) {
      _this.enterParameter(_this.state.parameter.itemReturnKey ? item[_this.state.parameter.itemReturnKey] : item);
    };

    _this.enterParameter = function (val) {
      _this.setState({
        enteredCommands: [].concat(_toConsumableArray(_this.state.enteredCommands), [{
          phase: _this.state.phase,
          copy: (_this.state.parameter.placeholder ? _this.state.parameter.placeholder : _this.state.parameter.key) + ': ' + val
        }])
      });
      _this.runner.next(val);
    };

    _this.reset = function () {
      _this.props.hideCommander();
      _this.setState({ phase: 'command', parameter: {}, enteredCommands: [] });
    };

    _this.enterCommand = _this.enterCommand.bind(_this);
    return _this;
  }

  _createClass(Commander, [{
    key: 'parameterRunner',
    value: /*#__PURE__*/_regeneratorRuntime2.default.mark(function parameterRunner(commandItem) {
      var loadedItem, i, parameterItems;
      return _regeneratorRuntime2.default.wrap(function parameterRunner$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              /** 💁 loaded as in loaded up, bogged down, made heavy */
              loadedItem = _extends({}, commandItem);
              i = 0;

            case 2:
              if (!(i < commandItem.parameters.length)) {
                _context.next = 19;
                break;
              }

              // mehhhhh
              parameterItems = commandItem.parameters[i].selector ? this.props.getItems(commandItem.parameters[i].selector) : null;

              this.setState({ parameter: commandItem.parameters[i], parameterItems: parameterItems });

              _context.t0 = _extends;
              _context.t1 = {};
              _context.t2 = loadedItem;
              _context.t3 = _defineProperty;
              _context.t4 = {};
              _context.t5 = commandItem.parameters[i].key;
              _context.next = 13;
              return commandItem.parameters[i];

            case 13:
              _context.t6 = _context.sent;
              _context.t7 = (0, _context.t3)(_context.t4, _context.t5, _context.t6);
              loadedItem = (0, _context.t0)(_context.t1, _context.t2, _context.t7);

            case 16:
              i++;
              _context.next = 2;
              break;

            case 19:

              this.reset();
              this.props.onSubmit(loadedItem);

            case 21:
            case 'end':
              return _context.stop();
          }
        }
      }, parameterRunner, this);
    })
  }, {
    key: 'enterCommand',
    value: function enterCommand(commandItem) {
      if (commandItem.parameters) {
        this.setState({ phase: 'parameters' });

        this.setState({
          enteredCommands: [].concat(_toConsumableArray(this.state.enteredCommands), [{ phase: this.state.phase, copy: commandItem.copy }])
        });

        this.runner = this.parameterRunner(commandItem);
        this.runner.next();
      } else {
        this.reset();
        this.props.onSubmit(commandItem);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactModal2.default,
        {
          appElement: this.props.appElement,
          style: {
            overlay: { zIndex: 20 },
            content: {
              padding: 0,
              border: 'none',
              borderRadius: 0,
              background: 'none',
              overflow: 'unset',
              right: 'unset',
              bottom: 'unset',
              position: 'unset'
            }
          },
          isOpen: this.props.isOpen,
          onRequestClose: this.reset,
          onAfterOpen: this.onAfterOpen
        },
        _react2.default.createElement(
          _StyledDiv2.default,
          null,
          this.props.withBuildup && this.state.enteredCommands.length > 0 && _react2.default.createElement(_Buildup2.default, { enteredCommands: this.state.enteredCommands }),
          this.state.phase === 'command' ? _react2.default.createElement(_FuzzyAutocomplete2.default, {
            itemStringKey: 'copy',
            onChange: this.enterCommand,
            placeholder: this.props.placeholder,
            items: this.props.commands
          }) : this.state.parameter.selector ? _react2.default.createElement(_FuzzyAutocomplete2.default, {
            itemStringKey: this.state.parameter.itemStringKey,
            items: this.state.parameterItems,
            onChange: this.selectParameterItem,
            placeholder: this.state.parameter.placeholder ? this.state.parameter.placeholder : this.state.parameter.key
          }) : _react2.default.createElement(_SimplePrompt2.default, {
            placeholder: this.state.parameter.placeholder ? this.state.parameter.placeholder : this.state.parameter.key,
            initialValue: '',
            onSubmit: this.enterParameter
          })
        )
      );
    }
  }]);

  return Commander;
}(_react.Component);

Commander.propTypes = {
  commands: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    action: _propTypes2.default.string,
    copy: _propTypes2.default.string
  })),
  onSubmit: _propTypes2.default.func.isRequired,
  placeholder: _propTypes2.default.string
};

Commander.defaultProps = {
  commands: null,
  placeholder: 'Type ? to see available commands'
};

exports.default = Commander;

// export default connect(null, dispatch => ({
//   dispatchAction: type => dispatch({ type }),
// }))(Commander);


//////////////////
// WEBPACK FOOTER
// ./~/react-commander/lib/components/Commander.js
// module id = 834
// module chunks = 107818501498521